import { OrderType } from 'everywhere/common';

export interface ITrip {
  cityCode: string;
  cityName: string;
  location: {
    latitude: number;
    longitude: number;
  };
  rank: number;
}

interface IDepatureTrip extends ITrip {
  airlineCode: string;
}

interface IDestinationTrip extends ITrip {
  cityImage: string;
  continentId: number;
  countryCode: string;
  themeIds: number[];
}

export interface ICommonItem {
  departure: IDepatureTrip;
  destination: IDestinationTrip;
  isOversea: boolean;
  totalFare: number;
  duration: number;
}

export interface IOverseaItem extends ICommonItem {
  stops: number;
}

export interface IDomesticItem extends ICommonItem {
  departure: {
    cityCode: string;
    cityName: string;
    airlineCode: string;
    location: {
      latitude: number;
      longitude: number;
    };
    fare: number;
    rank: number;
  };

  destination: {
    cityCode: string;
    cityImage: string;
    cityName: string;
    continentId: number;
    countryCode: string;
    fare: number;
    location: {
      latitude: number;
      longitude: number;
    };
    rank: number;
    themeIds: number[];
  };
}

export interface IFilterOption extends IFilterModalOption {
  theme: number;
  order: OrderType;
  country?: string;
}

interface IFilterModalOption {
  durationRange: [number, number];
  fareRange: [number, number];
  continentIds: number[];
  isDirectOnly: boolean;
}

enum ContinentType {
  ALL = 0,
  SOUTHEAST_ASIA = 1,
  CHINA = 2,
  JAPAN = 3,
  AMERICA = 4,
  EUROPE = 5,
  OCEANIA = 6,
  ASIA = 7,
  MIDDLE_EAST = 8,
  SOUTH_AMERICA = 9,
  AFRICA = 10,
  DOMESTIC = 11,
}

const continentDescMap = new Map<ContinentType, string>([
  [ContinentType.ALL, '전체'],
  [ContinentType.SOUTHEAST_ASIA, '동남아'],
  [ContinentType.JAPAN, '일본'],
  [ContinentType.CHINA, '중국'],
  [ContinentType.EUROPE, '유럽'],
  [ContinentType.OCEANIA, '남태평양'],
  [ContinentType.ASIA, '아시아'],
  [ContinentType.AMERICA, '미주'],
  [ContinentType.MIDDLE_EAST, '중동'],
  [ContinentType.SOUTH_AMERICA, '남미'],
  [ContinentType.AFRICA, '아프리카'],
  [ContinentType.DOMESTIC, '국내'],
]);

const sortFuncMap = new Map<
  OrderType,
  (a: ICommonItem, b: ICommonItem) => number
>([
  [
    OrderType.RANK,
    (a: ICommonItem, b: ICommonItem) => a.destination.rank - b.destination.rank,
  ],
  [
    OrderType.PRICE,
    (a: ICommonItem, b: ICommonItem) => a.totalFare - b.totalFare,
  ],
  [
    OrderType.DURATION,
    (a: ICommonItem, b: ICommonItem) => a.duration - b.duration,
  ],
]);

export { sortFuncMap, continentDescMap, ContinentType };
